import Map from './Map.vue';

export default Map;
